export default __webpack_public_path__ + "static/media/login-bg.e7fd0478.svg";